import ExcelJS from 'exceljs'
import { rateCodeCategoryNames, rateCodeCategoryValues } from 'features/RateCodes'

async function exportBucketsToExcel({
  buckets,
  fileName = 'rate-codes.xlsx',
  ignoreBrandLevel = true
}) {
  const workbook = new ExcelJS.Workbook()

  const rows = []

  Object.entries(buckets).forEach(([categoryKey, items]) => {
    const categoryLabel = rateCodeCategoryNames[categoryKey] || categoryKey

    ;(items || []).forEach(item => {
      if (!item || !item.code) return

      if (item.fromBrandLevel && ignoreBrandLevel) return

      rows.push({
        rateCode: String(item.code),
        category: categoryLabel
      })
    })
  })

  const sheet = workbook.addWorksheet('Rates')

  sheet.getRow(1).values = ['Rate code', 'Category']

  let writeRow = 2
  rows.forEach(r => {
    const hasContent =
      (r.rateCode && r.rateCode.trim()) || (r.category && String(r.category).trim())

    if (!hasContent) return

    sheet.getRow(writeRow).values = [r.rateCode, r.category]
    writeRow++
  })

  const firstDataRow = 2
  const lastDataRow = Math.max(writeRow - 1, firstDataRow)

  const lookup = workbook.addWorksheet('Lookup')
  lookup.getColumn(1).values = ['Categories', ...rateCodeCategoryValues]

  const lastEnumRow = rateCodeCategoryValues.length + 1
  const validationFormula = `=Lookup!$A$2:$A$${lastEnumRow}`

  const validationEndRow = Math.max(lastDataRow + 50, 200)
  const validationRange = `B2:B${validationEndRow}`

  sheet.dataValidations.add(validationRange, {
    type: 'list',
    allowBlank: true,
    formulae: [validationFormula],
    showErrorMessage: true,
    errorTitle: 'Invalid category',
    error: 'Please select a valid category from the dropdown.'
  })

  const buffer = await workbook.xlsx.writeBuffer()
  const blob = new Blob([buffer], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
  })

  const url = URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url
  a.download = fileName
  document.body.appendChild(a)
  a.click()
  document.body.removeChild(a)
  URL.revokeObjectURL(url)
}

export default exportBucketsToExcel
